var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.formatted.date !== '-')?_c('div',[_c('div',[_vm._v(_vm._s(_vm.formatted.date))]),(_vm.formatted.time)?_c('div',[_vm._v(_vm._s(_vm.formatted.time))]):_vm._e()]):_c('span',[_vm._v("-")])
}
var staticRenderFns = []

export { render, staticRenderFns }